import React, { Component } from "react";
import NewsPageAllNews from "./NewsPageAllNews";
import News from "./data/News";
import Section from "./Section";


class NewsPage extends Component {

    render() {
        return (
            <Section title="Le nostre Notizie">
                <section className="section cm-blogs">
                    <div className="container" id="news">
                        <div className="row">
                            {
                                            News.map(newsItem => <NewsPageAllNews newsItem={newsItem}></NewsPageAllNews>)
                            }      
                        </div>
                    </div>
                </section>
                </Section>
        );
    }
}

export default NewsPage;
